import base64 from 'react-native-base64';
import { firebase } from '../config/configureFirebase';
import AccessKey from './AccessKey';

export const fetchPlacesAutocomplete = (searchKeyword, sessionToken, language, components) => {
    return new Promise(async (resolve, reject) => {
        const { config } = firebase;
        // [FIX] Host Logic: Use current origin if available, otherwise raw functions URL or web.app fallback
        // Ideally we want to use the rewrite rule on the current domain to avoid CORS.
        const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
        const functionsUrl = process.env.REACT_APP_FUNCTIONS_URL ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;

        let host = origin || functionsUrl || `https://${config.projectId}.web.app`;
        try {
            const headers = await getAuthHeaders();
            let bodyValue = {
                "searchKeyword": searchKeyword,
                "sessiontoken": sessionToken
            };
            if (language) {
                bodyValue.language = language;
            }
            if (components) {
                bodyValue.components = components;
            }
            bodyValue = addGuestTokenIfNeeded(bodyValue, headers);

            fetch(`${host}/googleapi`, {
                method: 'POST',
                headers,
                body: JSON.stringify(bodyValue)
            }).then(response => {
                return response.json();
            })
                .then(json => {
                    if (json && json.searchResults) {
                        resolve(json.searchResults);
                    } else {
                        reject(json.error);
                    }
                }).catch(error => {
                    console.log(error);
                    reject("fetchPlacesAutocomplete Call Error")
                });
        } catch (error) {
            console.log(error);
            reject("fetchPlacesAutocomplete Auth Error");
        }
    });
}

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise(async (resolve, reject) => {
        const { config } = firebase;
        // [FIX] Host Logic
        const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
        const functionsUrl = process.env.REACT_APP_FUNCTIONS_URL ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;
        let host = origin || functionsUrl || `https://${config.projectId}.web.app`;
        try {
            const headers = await getAuthHeaders();
            let body = {
                "place_id": place_id
            };
            body = addGuestTokenIfNeeded(body, headers);

            fetch(`${host}/googleapi`, {
                method: 'POST',
                headers,
                body: JSON.stringify(body)
            }).then(response => {
                return response.json();
            })
                .then(json => {
                    if (json && json.coords) {
                        resolve(json.coords);
                    } else {
                        reject(json.error);
                    }
                }).catch(error => {
                    console.log(error);
                    reject("fetchCoordsfromPlace Call Error")
                });
        } catch (error) {
            console.log(error);
            reject("fetchCoordsfromPlace Auth Error");
        }
    });
}


export const fetchAddressfromCoords = (latlng) => {
    return new Promise(async (resolve, reject) => {
        const { config } = firebase;
        // [FIX] Host Logic
        const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
        const functionsUrl = process.env.REACT_APP_FUNCTIONS_URL ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;
        let host = origin || functionsUrl || `https://${config.projectId}.web.app`;
        try {
            const headers = await getAuthHeaders();
            let body = {
                "latlng": latlng
            };
            body = addGuestTokenIfNeeded(body, headers);

            fetch(`${host}/googleapi`, {
                method: 'POST',
                headers,
                body: JSON.stringify(body)
            }).then(response => {
                return response.json();
            })
                .then(json => {
                    if (json && json.address) {
                        resolve(json.address);
                    } else {
                        reject(json.error);
                    }
                }).catch(error => {
                    console.log(error);
                    reject("fetchAddressfromCoords Call Error")
                });
        } catch (error) {
            console.log(error);
            reject("fetchAddressfromCoords Auth Error");
        }
    });
}

/**
 * Helper: Get the best auth headers for apiCallGoogle server-side validation.
 * SEC-02 requires either: Bearer token, recaptchaToken, or guest_token.
 * We prefer Bearer token (logged-in user) and fall back to Basic + guest flag.
 */
const getAuthHeaders = async () => {
    const { config, auth } = firebase;
    const headers = {
        'Content-Type': 'application/json',
    };

    // Try Firebase Bearer token first (logged-in users)
    try {
        if (auth && auth.currentUser) {
            const idToken = await auth.currentUser.getIdToken();
            if (idToken) {
                headers["Authorization"] = "Bearer " + idToken;
                return headers;
            }
        }
    } catch (e) {
        // Silent fallback - user might not be logged in
    }

    // Fallback: Basic Auth (still needed for legacy compat)
    headers["Authorization"] = "Basic " + base64.encode(config.projectId + ":" + AccessKey);
    return headers;
};

/**
 * Helper: Build body with guest_token fallback for unauthenticated users.
 * If no Bearer token is available, we add a guest_token to pass SEC-02 validation.
 */
const addGuestTokenIfNeeded = (body, headers) => {
    // If we have no Bearer token, add a guest token so SEC-02 allows the call
    if (!headers["Authorization"] || !headers["Authorization"].startsWith("Bearer ")) {
        body.guest_token = "prefetch_" + Date.now();
    }
    return body;
};

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise(async (resolve, reject) => {
        const { config } = firebase;
        const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
        const functionsUrl = process.env.REACT_APP_FUNCTIONS_URL ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;
        let host = origin || functionsUrl || `https://${config.projectId}.web.app`;

        try {
            const headers = await getAuthHeaders();
            let body = {
                "start": startLoc,
                "dest": destLoc,
                "calltype": "matrix",
            };
            body = addGuestTokenIfNeeded(body, headers);

            fetch(`${host}/googleapi`, {
                method: 'POST',
                headers,
                body: JSON.stringify(body)
            }).then(response => {
                return response.json();
            })
                .then(json => {
                    if (json.error) {
                        console.log(json.error);
                        reject(json.error);
                    } else {
                        resolve(json);
                    }
                }).catch(error => {
                    console.log(error);
                    reject("getDistanceMatrix Call Error")
                })
        } catch (error) {
            console.log(error);
            reject("getDistanceMatrix Auth Error");
        }
    });
}

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise(async (resolve, reject) => {
        const { config } = firebase;
        const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
        const functionsUrl = process.env.REACT_APP_FUNCTIONS_URL ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;
        let host = origin || functionsUrl || `https://${config.projectId}.web.app`;

        try {
            const headers = await getAuthHeaders();
            let body = {
                "start": startLoc,
                "dest": destLoc,
                "calltype": "direction",
            };
            if (waypoints) {
                body["waypoints"] = waypoints;
            }
            body = addGuestTokenIfNeeded(body, headers);

            fetch(`${host}/googleapi`, {
                method: 'POST',
                headers,
                body: JSON.stringify(body)
            }).then(response => {
                return response.json();
            })
                .then(json => {
                    if (json.hasOwnProperty('distance_in_km')) {
                        resolve(json);
                    } else {
                        console.log(json.error);
                        reject(json.error);
                    }
                }).catch(error => {
                    console.log(error);
                    reject("getDirectionsApi Call Error")
                })
        } catch (error) {
            console.log(error);
            reject("getDirectionsApi Auth Error");
        }
    });
}

